module.exports = __webpack_public_path__ + "static/media/inbox.59c45d8b.svg";